import { ENDPOINTS } from 'src/constants/endpoints'

import { POLICY_API_VERSION } from 'src/app/auth/domain/models/terms-acceptance'
import { http } from 'src/interfaces/http'

export { POLICY_API_VERSION }

export const persistTermsAcceptance = async (): Promise<void> => {
  await http.post(ENDPOINTS.hanwha.policyAcceptance, {
    policy_version: POLICY_API_VERSION,
  })
}
